<template>
	<Col class="issues-list height-100">
		<template v-if="issues?.length > 0">
			<IssueCard class="height-100 mb-3" :key="issue.id" :issue="issue" v-for="issue in issues" />
		</template>
		<template v-else-if="!isLoading">
			<h3 class="reg empty-container flex-centerize">Nothing to see here</h3>
		</template>
	</Col>
</template>
<script>
import IssueCard from '@/views/IssuesView/IssueCard.vue';
export default {
	name: 'IssuesList',
	components: { IssueCard },
	props: { isLoading: { type: Boolean }, issues: { type: Array } },
};
</script>
<style scoped lang="scss">
.issues-list {
	display: flex;
	flex-direction: column;
	@media (max-width: 1100px) {
		padding: 10px 20px 10px 25px;
	}
}
.empty-container {
	margin-top: 150px;
}
</style>
